import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    marketModalContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '20px 20px',
      gap: '16px',
      minHeight: '500px',
      overflow: 'hidden',
      [theme.breakpoints.down('md')]: {
        padding: '0px',
        paddingBottom: '32px',
        gap: '12px',
        minHeight: 'auto',
        order: 2,
      },
    },
    marketModalTitle: {
      color: '#1A1919',
      fontSize: '36px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '40px',
      marginBottom: '0',
      margin: 0,
      padding: 0,
    },
    marketModalDescription: {
      color: '#505050',
      maxWidth: '350px',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
    },
    marketModalSubheading: {
      color: '#404040',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 'normal',
      marginTop: '8px',
    },
    marketModalChannelsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      marginTop: '8px',
    },
    marketModalChannelItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    marketModalChannelIcon: {
      // width: '24px',
      // height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '20px',
      flexShrink: 0,
      // '& svg': {
      //   width: '24px',
      //   height: '24px',
      // },
    },
    marketModalChannelText: {
      color: '#505050',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
    },
    marketModalPricing: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
      marginTop: '8px',
    },
    marketModalPricingRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '2px',
      marginBottom: '5px',
    },
    marketModalPricingLabel: {
      fontSize: '18px',
      color: '#505050',
      fontWeight: 400,
      lineHeight: 'normal',
    },
    marketModalPricingSmallLabel: {
      fontSize: '14px',
      color: '#505050',
      fontWeight: 400,
    },
    marketModalPricingStrikethrough: {
      fontSize: '18px',
      color: '#505050',
      backgroundColor: '#FCFCCF',
      fontWeight: 400,
      position: 'relative',
      display: 'inline-block',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '50%',
        width: '100%',
        height: '2px',
        background: '#505050',
        transform: 'rotate(-15deg)',
        pointerEvents: 'none',
      },
    },
    marketModalPricingAmount: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#505050',
    },
    marketModalButtonContainer: {
      marginTop: 'auto',
      paddingTop: '16px',
      cursor: 'pointer',
      borderTop: 'none',
      [theme.breakpoints.down('md')]: {
        paddingTop: '12px',
      },
    },
    marketModalImageContainer: {
      width: '369px',
      height: '554px',
      flexShrink: 0,
      backgroundColor: '#F3F0EA',
      borderRadius: '24px',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '100%',
        borderRadius: '16px 16px 0 0',
        order: 1,
        flexShrink: 1,
      },
    },
    marketModalContainer: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      position: 'relative',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        height: 'auto',
        // maxHeight: '90vh',
      },
    },
    marketModalDisclaimer: {
      position: 'absolute',
      bottom: '-10px',
      right: '5px',
      color: '#505050',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      padding: '0px 0px',
      [theme.breakpoints.down('md')]: {
        right: 'auto',
        left: '5px',
        bottom: '5px',
      },
    },
  }),
  { name: 'MarketBusinessModal' },
);

export const getModalStyles = (breakpointMdDown) => ({
  container: {
    padding: '15px 15px 0px 15px',
  },
  content: {
    padding: '25px',
    maxWidth: '100%',
    borderRadius: '24px',
    background: '#FFF',
    boxShadow: '0 4px 6.1px 0 rgba(174, 174, 174, 0.25)',
    overflow: breakpointMdDown ? 'auto' : 'hidden',
  },
});

export const getModalInputStyles = (breakpointMdDown) => ({
  maxWidth: breakpointMdDown ? '100%' : '927px',
  maxHeight: '650px',
  width: '927px',
  overflow: 'hidden',
  ...(breakpointMdDown && {
    overflow: 'auto',
  }),
});

export const getEnquireButtonStyles = () => ({
  button: {
    border: 'none',
  },
});

export default useStyles;
